/**
 * Main app navigation (bottom tab bar).
 * Single source of truth for tabs; add new sections (Prayers, Donations, etc.) here.
 */

export type TabVisibility = "always" | "authenticated";

export interface MainTab {
  id: string;
  path: string;
  pathEnd?: boolean; // for exact match (e.g. "/")
  label: string;
  icon: "home" | "calendar" | "clock" | "user" | "userCircle";
  visibility: TabVisibility;
}

/** Tabs shown in the bottom bar. Главная, Расписание, Профиль. */
export const MAIN_TABS: MainTab[] = [
  {
    id: "home",
    path: "/",
    pathEnd: true,
    label: "Главная",
    icon: "home",
    visibility: "always",
  },
  {
    id: "schedule",
    path: "/schedule",
    label: "Расписание",
    icon: "calendar",
    visibility: "always",
  },
  {
    id: "profile",
    path: "/profile",
    label: "Профиль",
    icon: "userCircle",
    visibility: "always",
  },
];

/** Reserved paths for future sections (no tab yet). */
export const RESERVED_PATHS = {
  events: "/schedule", // Афиша/календарь мероприятий
  prayers: "/prayers",
  needPrayer: "/need-prayer",
  university: "/university",
  materials: "/materials",
  courses: "/courses",
  donations: "/donations",
  church: "/church",
  feedback: "/feedback",
  pastor: "/pastor",
  worship: "/worship",
  homeGroups: "/home-groups",
  clubs: "/clubs",
  leadershipSchool: "/leadership-school",
  womensBreakfasts: "/womens-breakfasts",
  masterClasses: "/master-classes",
  familyClub: "/family-club",
  youth: "/youth",
  startCourse: "/start-course",
} as const;

export interface AccountForNav {
  canAccessAdmin?: boolean;
  permissions?: string[];
}

/**
 * Returns tabs to show in the bar.
 */
export function getVisibleTabs(_account: AccountForNav | null): MainTab[] {
  return MAIN_TABS;
}
